module.exports = __webpack_public_path__ + "img/full3-min.57b56dbf.png";